var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16LiveStatCornerMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08312 13.6042C8.06228 16.3542 11.9581 16.3334 12.9581 13.6042L17.0623 15.5417C17.5623 15.8125 17.3331 16.5209 16.7915 16.4375C16.2498 16.3542 15.6664 15.8959 15.3123 15.7292C14.9581 15.5625 14.9998 15.5834 14.9164 15.5834C14.4164 15.8125 13.9373 16.1042 13.4373 16.3334C11.2498 17.2917 8.79145 17.2917 6.60395 16.3334C6.10395 16.1042 5.62478 15.8125 5.12478 15.5834L3.20812 16.4375C2.70812 16.4375 2.47895 15.8542 2.91645 15.5625L7.08312 13.5834V13.6042Z",
    fill: "#FB2C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4795 7.22916V9.45832C10.167 9.39582 9.85449 9.39582 9.54199 9.45832V3.29166C9.54199 3.04166 9.93783 2.85416 10.1878 2.95832C10.667 3.14582 10.3753 3.70832 10.5212 3.95832L13.2503 6.72916C13.3753 6.83332 13.2295 7.20832 13.1253 7.20832H10.5003L10.4795 7.22916Z",
    fill: "#FB2C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16LiveStatCornerMobile);
export default __webpack_public_path__ + "static/media/kbv-v16-live-stat-corner-mobile.e06d3a3c4c134aee3e9ac82c5cdd3960.svg";
export { ForwardRef as ReactComponent };